import { render, staticRenderFns } from "./EntryMessageHistoryMessageDetail.vue?vue&type=template&id=1186271a"
import script from "./EntryMessageHistoryMessageDetail.vue?vue&type=script&lang=js"
export * from "./EntryMessageHistoryMessageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports